module.exports = __webpack_public_path__ + "img/help_other_hf@3x.20494e04.png";